import { Component } from '@angular/core';

@Component({
    selector: 'app-manage-user-page',
    templateUrl: './manage-user-page.component.html',
    styleUrls: ['./manage-user-page.component.scss'],
    standalone: false
})
export class ManageUserPageComponent {}
